// /onboarding/shape — the sixth step (fifth for seats), one per shape
// (board 25 v2 shape--1…6): the team (staff), places with hourly bands
// (place), periods with the deposit (business), unit types (unit), programs
// with their first sessions (seat), tables with the deposit (table). The
// shared guards first: a session, a business, its scheduling written.

import { Navigate } from 'react-router-dom';
import { sessionStore } from '@/lib/auth';
import { unscheduledRoute } from '../../data/enroll';
import { ONB } from '../../data/flow';
import { shapeOf } from '../../data/shapes';
import { useOnboarding } from '../../state';
import { PeriodsStep } from './PeriodsStep';
import { PlacesStep } from './PlacesStep';
import { TeamStep } from './TeamStep';
import { ProgramsStep } from './ProgramsStep';
import { TablesStep } from './TablesStep';
import { UnitTypesStep } from './UnitTypesStep';

export function ShapeStep() {
  const { createdId, type } = useOnboarding();
  if (!sessionStore.isAuthenticated()) return <Navigate to={ONB.phone} replace />;
  if (!createdId) return <Navigate to={ONB.hours} replace />;
  const pending = unscheduledRoute();
  if (pending) return <Navigate to={pending} replace />;
  switch (shapeOf(type) ?? 'staff') {
    case 'staff':
      return <TeamStep />;
    case 'place':
      return <PlacesStep businessId={createdId} categoryId={type?.id ?? ''} />;
    case 'business':
      return <PeriodsStep businessId={createdId} />;
    case 'unit':
      return <UnitTypesStep businessId={createdId} />;
    case 'seat':
      return <ProgramsStep businessId={createdId} />;
    case 'table':
      return <TablesStep businessId={createdId} />;
  }
}
